import { CategoriesI18n } from "@/locales/base.message.locales";

export const categories: CategoriesI18n = {
  title: '<p style="font-weight: bold;">CATEGORIAS</p>',
  flag: "Locais marcados por usuários com um problema relacionado a esta categoria",
  go_to_challenges: "Ir para os Desafios",
  search: "Buscar desafio",
  loading: "Carregando categorias...",
  loading_single: "Carregando...",
  text: `
     <p class="text-justify">
     A urgência dos resultados globais dos 17 ODS 2030, alinhados aos problemas urbanos, sociais, ambientais e econômicos enfrentados diariamente em todo planeta, exigem novas soluções: rápidas, inovadoras e transformadoras, na escala que o tamanho do problema requer.
     </p>`
};
